const styles = theme => ({
  enterOverlay: {
    zIndex: 1000,
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    padding: 20,
    backgroundColor: '#000000'
  },
  enterElement: {
    margin: 'auto',
    fontFamily: 'monospace',

    '& button': {
      fontFamily: 'monospace'
    }
  }
});

export { styles };

// Commit trace: 2025-11-24T01:41:17 - fix: resolve minor issue in Template.styles.js

// Commit trace: 2026-03-29T04:42:30 - fix: correct typo in Template.styles.js
